import { ContextTelaProvider } from '@pages/DicasOtimizacao/telaContext';

export function CardSeo({ children }) {
  return (
    <div className="w-full border-[2px] border-solid border-[#eceef2] rounded-md">
      <div className="p-4 flex gap-4">
        <ContextTelaProvider>{children}</ContextTelaProvider>
      </div>
    </div>
  );
}
